
<template>
  <tbody style="cursor: pointer;">
    <v-menu
      offset-y
      max-width="200"
      nudge-right="100"
      :close-on-content-click="false"
      v-model="menu[booking.id.toString()]"
      v-if="booking != null"
    >
      <template v-slot:activator="{ on }">
        <tr
          v-on="on"
          v-if="booking != null"
          valign="top"
          @click="setSelectedBooking(booking.id, -1);"
          v-bind:style="colorForBooking(booking)"
        >
          <td>
            <div class="fixed-table-row" v-if="booking.taxi != null && booking.driver != null">
              <span v-on="on">
                <b>{{ booking.driver.callsign}}</b>
                {{shortName(booking.driver.name)}}
              </span>
            </div>
          </td>
          <td>{{timeForBooking(booking.pickup_time, booking.asap)}}</td>
          <td>{{booking.pickup_time.substring(0, 10)}}</td>
          <td>
            <div class="fixed-table-row">{{prettify(booking.pickup_location.description)}}</div>
          </td>
          <td>
            <ViasForBooking :booking="booking" />
          </td>
          <td>
            <div class="fixed-table-row">{{destinationForBooking(booking)}}</div>
          </td>
          <td>
            <div class="fixed-table-row">{{nameOrRoomForCustomerForBooking(booking)}}</div>
          </td>
          <td>
            <AttributesForBookingCell :booking="booking" />
          </td>
        </tr>
      </template>
      <BookingMenu
        @copy="copy(booking)"
        @edit="edit(booking.id)"
        @close="menu[booking.id.toString()] = false"
        :booking="booking"
      />
    </v-menu>
  </tbody>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";

import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

export default {
  name: "HistoryTableRows",
  components: {
    AttributesForBookingCell,
    BookingMenu,
    ViasForBooking
  },
  props: {
    booking: Object,
    selectedTaxi: Number,
    selectedBooking: Number,
    setSelectedTaxi: Function,
    setSelectedBooking: Function
  },
  computed: {},
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: {}
    };
  },
  methods: {
    copy: function(booking) {
      this.$emit("copy", booking);
    },
    edit: function(bookingID) {
      this.$emit("edit", bookingID);
    },
    reassign: function(b) {
      this.$emit("reassign", b);
    },
    colorForBooking: function(booking) {
      var style = {};

      if (booking.state == "cancelled") {
        style.backgroundColor = "#a1a1a1";
      }

      return style;
    },
    timeForBooking: function(timeString, asap) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      var timeFormatted = `${time.format("HH:mm")}`;

      if (asap == true) {
        timeFormatted = timeFormatted;
      }

      return timeFormatted;
    },
    minutesToHoursMinutesString: function(minutes) {
      var duration = moment.duration(minutes, "minutes");

      if (minutes == 0) {
        return 0;
      }

      var hoursMinutesString = Overwatch.durationToHoursMinutesString(
        duration,
        ""
      );

      return hoursMinutesString;
    },
    colorForFollowOn: function(booking) {
      var style = {};

      if (this.selectedBooking == booking.id) {
        // style.backgroundColor = "red";
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.1)";
      }

      return style;
    },
    prettify: function(d) {
      return Overwatch.prettifyAddress(d);
    },
    destinationForBooking: function(b) {
      return Overwatch.destinationForBooking(b);
    },
    shortName: function(d) {
      return d.substring(0, 10);
    },
    nameOrRoomForCustomerForBooking: function(b) {
      var name = Overwatch.nameForCustomerForBooking(b);

      if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number;
      } else {
        return b.customer_name;
      }
    },
    tooltipForTaxi: function(taxi, driver) {
      taxi.driver = driver;
      var ow = new Overwatch([], []);

      return ow.tooltipForTaxi(taxi);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.fixed-table-row {
  overflow: hidden;
  height: 16px;
}
</style>
